import styled from 'styled-components'

import { FireButton } from '@nx/fire/button'

export const ConsignmentPromoContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));
  gap: 20px;
  margin-top: 60px;
`

export const StyledFireButton = styled(FireButton)`
  margin-bottom: -8px;
`
